import { ParticipantType } from "@multiweb/types/multiweb";

export interface IParticipantStateInformation {
    /**
     * Typ uživatele / role.
     */
    readonly participanttype: ParticipantValueType<ParticipantType>;
    /**
     * Identifikace uživatele / role.
     */
    readonly id: ParticipantValueType<number>;
    /**
     * Název uživatele / role.
     */
    readonly name: ParticipantValueType<string>;
}

export interface IUserParticipantInformation extends IParticipantStateInformation {
    /**
     * Fyzické jméno uživatele.
     */
    readonly personname: ParticipantValueType<string>;
}

export interface IRoleParticipantsInformation extends IParticipantStateInformation {
    /**
     * Název role.
     */
    readonly actualrolename: ParticipantValueType<string>;
    /**
     * Uživatelé role.
     */
    readonly roleusers: ParticipantValueType<IUserParticipantInformation[]>;
}

type ParticipantValueType<T> = ({ value: T});

export { ParticipantCustomMethodDataType } from "./datasources/participantsDataSource";
